import { DESKTOP_NAV_BAR_HEIGHT } from "Components/NavBar/constants"

export const DESKTOP_HEIGHT = `calc(100vh - ${DESKTOP_NAV_BAR_HEIGHT}px)`
export const MIN_LIST_WIDTH = 370
